export default {
  method: 'get',
  // 基础url前缀
  // baseURL: 'http://localhost:9757/',
  // baseURL: 'http://111.198.19.12:8083/webapi/',
  baseURL: 'https://broadcast-ewarranty.panasonic.cn/webapi/',
  // 请求头信息
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  // 参数
  data: {},
  // 设置超时时间
  timeout: 10000,
  // 携带凭证
  withCredentials: true,
  // 返回数据类型
  responseType: 'json'
}



// WEBPACK FOOTER //
// ./src/http/config.js